import { Component } from '@angular/core';
import { PageService, SortService, FilterService, ResizeService, FreezeService } from '@syncfusion/ej2-angular-grids';
import { PaymentResponseDto } from '../../shared/models/paymentResponseDto';
import { ViewUserPaymentComponent } from '../../view-user-payment/view-user-payment.component';
import { RequestType } from '../../enums/request-type.enum';
import { ServerPagedHistoryGrid } from '../../shared/grid/server-paged-history-grid';
import type { GridFields } from '../../shared/utils/grid-request';

@Component({
    selector: 'xp-user-payment-history',
    templateUrl: './user-payment-history.component.html',
    styleUrl: './user-payment-history.component.scss',
    providers: [PageService, SortService, FilterService, ResizeService, FreezeService]
})
export class UserPaymentHistoryComponent extends ServerPagedHistoryGrid<PaymentResponseDto> {
    protected readonly requestType = RequestType.Payment;
    protected readonly path = 'payment';
    protected readonly completedRoute = 'payment-completed-requests';
    protected readonly filterKey = 'payment';
    protected readonly sheetName = 'Payment Requests';
    protected readonly exportFileName = 'User Payment Requests';
    protected readonly fields: GridFields = {
        id: 'number',
        dateRequested: 'date',
        matterNo: 'number',
        matter: 'text',
        clientName: 'text',
        paymentType: 'text',
        paymentMethod: 'text',
        reason: 'text',
        currencyCode: 'text',
        amount: 'number',
        clientBankAccountName: 'text',
        payee: 'text',
        partnerAuthorisingName: 'text',
        dateAuthorised: 'date',
        dateTransaction: 'date',
        recentStatus: 'text',
        returnReason: 'text'
    };

    onViewPayment(request: PaymentResponseDto): void {
        this.openDetails(ViewUserPaymentComponent, request, '90%');
    }

    protected exportRow(item: PaymentResponseDto): Record<string, unknown> {
        const row: Record<string, unknown> = {
            'Request Id': item.id || '',
            'Requested Date': this.exportDate(item.dateRequested),
            'Matter No': item.matterNo || '',
            'Matter': item.matter || '',
            'Client': item.clientName || '',
            'Payment Type': item.paymentType || '',
            'Currency': item.currencyCode ?? '',
            'Amount': item.amount ?? '',
            'Payee': item.payee || '',
            'Partner': item.partnerAuthorisingName || '',
            'Authorised Date': this.exportDate(item.dateAuthorised),
            'Transaction Date': this.exportDate(item.dateTransaction),
            'Status': item.recentStatus || ''
        };
        if (this.isCompletedTab) {
            row['Payment Method'] = item.paymentMethod || '';
            row['Reason for Payment'] = item.reason || '';
            row['Client Bank Account Name'] = item.clientBankAccountName || '';
            row['Rejected Reason'] = item.returnReason || '';
        }
        return row;
    }
}
